import { TFormalOffer } from './formalOffers.types';

export const getHasSuitabilityInfo = (formalOffer: TFormalOffer): boolean => {
    return Boolean(formalOffer.suitability_info);
};
